import { feature as sessionServiceFeature } from '@central-products/session-service';

export const sessionServicePlugin = {
  beforeBootstrap({ addBootstrapperFeature, params }) {
    addBootstrapperFeature(sessionServiceFeature, params);
  },
};
